'use client';

import { useEffect, useState } from 'react';
import { useAppSelector } from '@/store/hook';
import { selectIsGlobalLoading } from '@/features/ui/uiLoadingSlice';

export const useGlobalSkeletonLoading = (minShowMs = 1000) => {
  const isGlobalLoading = useAppSelector(selectIsGlobalLoading);
  const [isSkeletonVisible, setIsSkeletonVisible] = useState(false);

  useEffect(() => {
    let timer: ReturnType<typeof setTimeout> | undefined;

    if (isGlobalLoading) {
      // 一進入 loading 狀態就顯示 skeleton
      setIsSkeletonVisible(true);
    } else if (isSkeletonVisible) {
      // loading 結束 → 等至少 minShowMs 再關閉 skeleton
      timer = setTimeout(() => {
        setIsSkeletonVisible(false);
      }, minShowMs);
    }

    return () => {
      if (timer) clearTimeout(timer);
    };
  }, [isGlobalLoading, isSkeletonVisible, minShowMs]);

  return isSkeletonVisible;
};
